import { useMemo } from "react";
import * as React from "react";

import { LoginProvider } from "./login-provider";
import type { IProvider } from "./login-provider/types";
import { FormButtonList } from "./styles";

interface ILoginProvidersProps {
  readonly section: "Login" | "Signup";
}

const LoginProviders: React.FC<ILoginProvidersProps> = ({
  section,
}: ILoginProvidersProps): JSX.Element => {
  const authProviders = useMemo(
    (): IProvider[] => [
      {
        auth0Connection: "google-oauth2",
        imageAlt: "google-auth",
        imageId: "integrates/login/loginGoogleLogo",
        name: "Google",
        section,
      },
      {
        auth0Connection: "microsoft",
        imageAlt: "microsoft-oauth",
        imageId: "integrates/login/loginMicrosoftLogo",
        name: "Microsoft",
        section,
      },
      {
        auth0Connection: "bitbucket",
        imageAlt: "bitbucket-oauth",
        imageId: "integrates/login/loginBitBucketLogo",
        name: "Bitbucket",
        section,
      },
    ],
    [section],
  );

  const providers: JSX.Element[] = useMemo(
    (): JSX.Element[] =>
      authProviders.map(
        (provider: IProvider): JSX.Element => (
          <LoginProvider key={provider.imageAlt} {...provider} />
        ),
      ),
    [authProviders],
  );

  return <FormButtonList>{providers}</FormButtonList>;
};

export { LoginProviders };
